(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["outbound-click-tracking"] && !Shopify.designMode) return;
  try {
    const bananaBreadPage = document.querySelector('[data-template="page.banana-bread"]');

  if (bananaBreadPage) {
    bananaBreadPage.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest('[data-outbound-click]');

      if (!link || !bananaBreadPage.contains(link)) return;

      const label = link.textContent.replace(/\s+/g, ' ').trim();
      const detail = {
        destination: link.dataset.outboundDestination || 'unknown',
        url: link.href,
        label,
        page: 'banana-bread',
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'outbound_click',
        outbound_destination: detail.destination,
        outbound_url: detail.url,
        outbound_label: detail.label,
        outbound_page: detail.page,
      });

      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish('outbound_click', detail);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
